import Avatar from "./basic-14-avatar.png";
import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic14 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #14";
    this.id = "14";
    this.url = "/ai/carousels/basic-14";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Jon Snow",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@jon-snow",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#26292B",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#8F7FF3",
        },
        {
          label: "Secondary Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#FFFFFF",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Big Shoulders Display",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Instrument Sans",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "How to write hook that don't suck",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "72px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "900",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Keep it short",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "800",
              },
              textAlign: {
                value: "center",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Your hook should fit on one line and get a point across quickly.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Tap into emotions",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "800",
              },
              textAlign: {
                value: "center",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Make your readers feel something when they read your first line.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Address a problem",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "800",
              },
              textAlign: {
                value: "center",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Start with one problem or challenge your reader faces and offer the solution in the body of your post.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "SHARE YOUR THOUGHTS IN the COMMENTS",
            max_words: 2,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "72px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "900",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getBackgroundColorVariant(common_settings) {
    return this.getBackgroundColor(common_settings) + "20";
  }

  getBackgroundColorVariantSecond(common_settings) {
    return this.getBackgroundColor(common_settings) + "40";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Big Shoulders Display";
  }

  getSecondaryFont(common_settings) {
    return common_settings.elements[7]?.value || "Instrument Sans";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div
          className="absolute w-full h-full"
          style={{
            backgroundColor: this.getPrimaryColor(commonSettings),
          }}
        />
        <div
          className="absolute h-full inset-x-0 px-[32px] flex gap-[16px] items-center"
          style={{
            fontFamily: this.getPrimaryFont(commonSettings),
          }}
        >
          <div
            className="uppercase text-[72px] leading-[72px] font-[900]"
            style={{
              color: this.getSecondaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
        </div>
        <div className="absolute inset-x-0 top-[440px] left-[32px] flex gap-[8px] items-center">
          <img
            className="object-cover w-[24px] h-[24px] rounded-full"
            src={
              commonSettings.elements[1].value.image
                ? commonSettings.elements[1].value.image
                : LogoPlaceholder
            }
            style={{
              backgroundColor: this.getSecondaryColor(commonSettings),
            }}
            alt=""
          />

          <p
            className="font-semibold text-[18px] leading-[28px]"
            style={{
              color: this.getBackgroundColor(commonSettings),
            }}
          >
            {commonSettings.elements[0].value}
          </p>
        </div>
        <div className="absolute inset-x-0 top-[448px] left-[272px]">
          <svg
            width="97"
            height="20"
            viewBox="0 0 97 20"
            fill="current"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 10.2715C19.9397 12.8956 18.89 15.3646 16.7644 17.3557C15.7925 18.2662 14.6695 18.9393 13.4193 19.3929C12.0507 19.8904 10.5899 20.0826 9.1393 19.9559C7.68869 19.8292 6.2833 19.3867 5.02156 18.6595C4.92447 18.6036 4.846 18.6213 4.75437 18.6548C3.57485 19.0849 2.39532 19.5167 1.21407 19.9408C0.863685 20.0665 0.540869 19.9904 0.276656 19.7286C0.00871841 19.463 -0.0672676 19.1375 0.060369 18.7815C0.489467 17.5835 0.923034 16.3871 1.36107 15.1924C1.37514 15.1587 1.38069 15.1221 1.37723 15.0857C1.37376 15.0494 1.36139 15.0144 1.34121 14.984C0.912669 14.2471 0.582648 13.457 0.359595 12.6342C0.0714628 11.591 -0.0428892 10.5074 0.0211344 9.42699C0.151585 7.27478 0.89398 5.36025 2.24832 3.68341C3.33422 2.34179 4.68831 1.35223 6.29222 0.712482C7.66774 0.160784 9.14935 -0.075481 10.6281 0.021055C14.4555 0.256582 17.8163 2.67595 19.2632 6.24166C19.7514 7.44389 19.9898 8.69681 20 10.2715Z"
              fill={this.getBackgroundColor(commonSettings)}
            />
            <path
              d="M55.2253 0.455078C52.1855 0.455078 50.5003 2.62945 50.5003 2.62945C50.5003 2.62945 48.815 0.455078 45.7753 0.455078C42.5854 0.455078 40.0002 3.01647 40.0002 6.17712C40.0002 10.5165 45.1579 14.7217 46.5953 16.0502C48.2512 17.5796 50.5003 19.5459 50.5003 19.5459C50.5003 19.5459 52.7494 17.5796 54.4052 16.0502C55.8427 14.7217 61.0003 10.5165 61.0003 6.17712C61.0003 3.01647 58.4152 0.455078 55.2253 0.455078Z"
              fill={this.getBackgroundColor(commonSettings)}
            />
            <path
              d="M96.2734 18.4158C96.2734 18.8848 95.7403 19.1548 95.3622 18.8774L88.9757 14.1916C88.7742 14.0438 88.4999 14.0438 88.2984 14.1916L81.9119 18.8774C81.5338 19.1548 81.0007 18.8848 81.0007 18.4158V1.02759C81.0007 0.7114 81.2571 0.455078 81.5732 0.455078H95.7009C96.0171 0.455078 96.2734 0.7114 96.2734 1.02759V18.4158Z"
              fill={this.getBackgroundColor(commonSettings)}
            />
          </svg>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute h-full inset-x-0 px-[32px] flex flex-col gap-[12px] justify-center">
          <div
            className="text-[60px] leading-[60px] font-extrabold text-center uppercase"
            style={{
              color: this.getPrimaryColor(commonSettings),
              fontFamily: this.getPrimaryFont(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="text-[18px] leading-[28px] font-normal text-center"
            style={{
              color: this.getSecondaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div
          className="absolute h-full inset-x-0 px-[32px] flex gap-[16px] items-center"
          style={{
            fontFamily: this.getPrimaryFont(commonSettings),
          }}
        >
          <div
            className="uppercase text-[72px] leading-[72px] font-[900]"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getSecondaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 && (
          <>
            <div
              className="absolute inset-x-0 w-full top-[32px] px-[32px] flex justify-between items-center opacity-50 font-medium"
              style={{
                color: this.getSecondaryColor(commonSettings),
              }}
            >
              <p className="text-[14px] leading-[20px] whitespace-nowrap">
                {commonSettings.elements[2].value}
              </p>
              <p className="text-[14px] leading-[20px]">{`${
                index + 1
              } / ${carouselLength}`}</p>
            </div>

            <div className="absolute inset-x-0 top-[440px] left-[32px] flex gap-[8px] items-center">
              <img
                className="object-cover w-[24px] h-[24px] rounded-full"
                src={
                  commonSettings.elements[1].value.image
                    ? commonSettings.elements[1].value.image
                    : LogoPlaceholder
                }
                style={{
                  backgroundColor: this.getPrimaryColor(commonSettings),
                }}
                alt=""
              />

              <p
                className="font-semibold text-[18px] leading-[28px] whitespace-nowrap"
                style={{
                  color: this.getSecondaryColor(commonSettings),
                }}
              >
                {commonSettings.elements[0].value}
              </p>
            </div>
            <div
              className="absolute top-[428px] left-[328px] w-[40px] h-[40px] flex items-center justify-center"
              style={{
                backgroundColor: this.getPrimaryColor(commonSettings),
                color: this.getBackgroundColor(commonSettings),
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.4764 6.16609L6.00637 1.69609L7.18487 0.517578L13.6667 6.99943L7.18487 13.4812L6.00637 12.3027L10.4764 7.83276H0.333374V6.16609H10.4764Z"
                  fill={this.getBackgroundColor(commonSettings)}
                />
              </svg>
            </div>
          </>
        )}
        {index === carouselLength - 1 && (
          <div
            className="absolute inset-x-0 w-full top-[32px] px-[32px] flex justify-between items-center font-medium"
            style={{
              color: this.getBackgroundColor(commonSettings),
            }}
          >
            <p className="text-[14px] leading-[20px]">
              {commonSettings.elements[2].value}
            </p>
            <p className="text-[14px] leading-[20px]">{`${
              index + 1
            } / ${carouselLength}`}</p>
          </div>
        )}
      </div>
    );
  }
}

export default Basic14;
